import { subDays, format, addYears } from 'date-fns';
import { MMMM_DD_YYYY_FORMAT, MMMM_DD_FORMAT } from '@/const';

export function mapAuthCodeToMessage(authCode: string) {
  switch (authCode) {
    case 'auth/wrong-password':
      return 'Password is incorrect.';

    case 'auth/user-not-found':
      return 'Email was not found.';

    case 'auth/invalid-email':
      return 'Email is invalid.';

    case 'auth/too-many-requests':
      return 'Access to this account has been temporarily disabled due to multiple failed login attempts.';

    case 'auth/weak-password':
      return 'Password is invalid. It must be at least six characters long.';

    case 'auth/invalid-action-code':
    case 'auth/expired-action-code':
      return 'The reset password link is invalid. Please navigate to Login page and click "Forgot Password" to request a new link.';

    case 'auth/requires-recent-login':
      return 'This operation requires a recent login. Please navigate to the Login page and log in again.';

    default:
      return 'An unknown error occurred.';
  }
}

export const truncateString = (str: string, maxLength = 20) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + '...';
  } else {
    return str;
  }
};

export const isDateInRange = (dateString: string, startDate: Date, endDate: Date) => {
  const date = new Date(dateString);
  return date >= startDate && date <= endDate;
};

export const getFormattedDateRange = (numberOfDays: any) => {
  const pastDate = subDays(new Date(), numberOfDays);
  const todayDate = format(new Date(), MMMM_DD_FORMAT);
  if (numberOfDays === '365') {
    const nextYear = addYears(pastDate, 1);
    return `${format(pastDate, MMMM_DD_YYYY_FORMAT)} - ${format(nextYear, MMMM_DD_YYYY_FORMAT)}`;
  }
  return `${format(pastDate, MMMM_DD_FORMAT)} - ${todayDate}`;
};

export function debounce(func: any, delay: number) {
  let timeout: any;
  return function (...args: any[]) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}
